/*
 * Paco Routine — bundle buy-box logic.
 *
 *  - Bundle selection (1/2/3 bags) drives the headline per-bag price and gift unlocks.
 *  - All card prices are static marketing copy rendered in Liquid; JS does not rewrite them.
 *  - Subscribe (Seal selling plan) vs Buy Once toggle only controls whether selling_plan is
 *    sent on add and swaps the toggle label.
 *  - CTA adds the selected bundle variant (+ selling_plan when subscribing) plus every unlocked
 *    $0 gift variant in one /cart/add request, then opens the theme's existing cart drawer.
 */
(function () {
  function initBuybox(root) {
    if (!root || root.dataset.pacoInit === 'true') return;
    root.dataset.pacoInit = 'true';

    var cartAddUrl = root.dataset.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-bundle]'));
    var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-gift]'));
    var steps = Array.prototype.slice.call(root.querySelectorAll('.paco-routine__step'));
    var headlinePrice = root.querySelector('[data-headline-price]');
    var headlineCompare = root.querySelector('[data-headline-compare]');
    var submit = root.querySelector('[data-submit]');
    var spinner = root.querySelector('.loading__spinner');
    var errorEl = root.querySelector('[data-error]');
    var modeToggle = root.querySelector('[data-mode-toggle]');
    var modeToggleText = root.querySelector('[data-mode-toggle-text]');

    if (bundles.length === 0) return;

    var subscribeAvailable = bundles.some(function (b) {
      return !!b.getAttribute('data-sub-plan');
    });
    var isLoading = false;
    var selected =
      bundles.filter(function (b) {
        var input = b.querySelector('[data-bundle-radio]');
        return input && input.checked;
      })[0] || bundles[0];

    function renderHeadline() {
      if (!selected) return;
      if (headlinePrice) {
        headlinePrice.textContent =
          selected.getAttribute('data-price') || selected.getAttribute('data-perbag') || '';
      }
      if (headlineCompare) {
        headlineCompare.textContent = selected.getAttribute('data-compare') || '';
      }
    }

    function renderSteps() {
      if (steps.length === 0) return;
      var bags = selected ? parseInt(selected.getAttribute('data-bags'), 10) || 1 : 1;
      steps.forEach(function (step, i) {
        // All steps up to the selected bag count are green (cumulative),
        // and the connecting line is green when the next step is also active.
        step.classList.toggle('is-active', i + 1 <= bags);
        step.classList.toggle('is-linked', i + 1 < bags);
      });
    }

    var giftsReady = false;
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function burstConfetti(el) {
      if (reduceMotion) return;
      var host = el.querySelector('.paco-routine__gift-media') || el;
      var W = 180;
      var H = 180;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var canvas = document.createElement('canvas');
      canvas.className = 'paco-routine__confetti';
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      host.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);

      var cx = W / 2;
      var cy = H / 2;
      var colors = ['#EE6F4B', '#33915C', '#134E0D', '#ffd166', '#ff8fab', '#4cc9f0', '#ffffff'];
      var parts = [];
      for (var i = 0; i < 34; i++) {
        // Bias the burst upward and outward, like a real popper.
        var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2;
        var speed = 3.5 + Math.random() * 5;
        parts.push({
          x: cx + (Math.random() - 0.5) * 12,
          y: cy + (Math.random() - 0.5) * 8,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          w: 5 + Math.random() * 5,
          h: 8 + Math.random() * 6,
          color: colors[(Math.random() * colors.length) | 0],
          rot: Math.random() * Math.PI,
          vrot: (Math.random() - 0.5) * 0.45,
          tilt: Math.random() * Math.PI,
          tiltV: 0.12 + Math.random() * 0.16,
          shape: Math.random() < 0.28 ? 'circle' : 'rect'
        });
      }

      var gravity = 0.16;
      var drag = 0.986;
      var life = 1500;
      var start = performance.now();

      function frame(now) {
        var t = now - start;
        ctx.clearRect(0, 0, W, H);
        var alpha = t < life - 450 ? 1 : Math.max(0, (life - t) / 450);
        for (var j = 0; j < parts.length; j++) {
          var p = parts[j];
          p.vx *= drag;
          p.vy = p.vy * drag + gravity;
          p.x += p.vx;
          p.y += p.vy;
          p.rot += p.vrot;
          p.tilt += p.tiltV;
          var flip = Math.abs(Math.cos(p.tilt)); // simulate 3D tumbling
          ctx.save();
          ctx.globalAlpha = alpha;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          if (p.shape === 'circle') {
            ctx.beginPath();
            ctx.ellipse(0, 0, p.w / 2, (p.h / 2) * flip + 1, 0, 0, Math.PI * 2);
            ctx.fill();
          } else {
            ctx.scale(1, flip * 0.85 + 0.15);
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          }
          ctx.restore();
        }
        if (t < life) {
          requestAnimationFrame(frame);
        } else if (canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
      }
      requestAnimationFrame(frame);
    }

    function renderGifts() {
      var bags = selected ? parseInt(selected.getAttribute('data-bags'), 10) || 0 : 0;
      gifts.forEach(function (g) {
        var need = parseInt(g.getAttribute('data-gift-unlock'), 10) || 1;
        var unlocked = bags >= need;
        var was = g.getAttribute('data-was-unlocked') === 'true';
        g.classList.toggle('is-unlocked', unlocked);
        g.classList.toggle('is-locked', !unlocked);
        var status = g.querySelector('[data-gift-status]');
        if (status) {
          status.textContent = unlocked ? 'Unlocked' : need + '+ Bags';
        }
        // Confetti only when a gift is newly unlocked (not on first render).
        if (giftsReady && unlocked && !was) {
          burstConfetti(g);
        }
        g.setAttribute('data-was-unlocked', unlocked ? 'true' : 'false');
      });
      giftsReady = true;
    }

    function renderModeToggle() {
      // "Buy Once" is a direct one-time purchase button. It only appears when a
      // subscription plan exists (otherwise TRY IT NOW already buys once).
      if (!subscribeAvailable || !modeToggle) {
        if (modeToggle) modeToggle.hidden = true;
        return;
      }
      modeToggle.hidden = false;
      if (modeToggleText) {
        var price = selected && selected.getAttribute('data-buyonce');
        if (price) {
          var prefix = modeToggle.getAttribute('data-buyonce-prefix') || 'Buy Once for';
          modeToggleText.textContent = prefix + ' ' + price;
        } else {
          modeToggleText.textContent = modeToggle.getAttribute('data-buyonce-label') || 'Buy Once';
        }
      }
    }

    function selectBundle(b) {
      selected = b;
      bundles.forEach(function (item) {
        var input = item.querySelector('[data-bundle-radio]');
        var isSel = item === b;
        item.classList.toggle('is-selected', isSel);
        item.classList.toggle('is-unavailable', item.getAttribute('data-available') === 'false');
        if (input) input.checked = isSel;
      });
      if (submit) submit.disabled = b.getAttribute('data-available') === 'false';
      renderHeadline();
      renderSteps();
      renderGifts();
      renderModeToggle();
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function buildItems(purchaseMode) {
      var items = [];
      var main = { id: parseInt(selected.getAttribute('data-variant-id'), 10), quantity: 1 };
      var plan = selected.getAttribute('data-sub-plan');
      if (purchaseMode === 'subscribe' && plan) {
        main.selling_plan = parseInt(plan, 10);
      }
      items.push(main);

      // Free gifts are a subscription perk — only include them on subscribe orders.
      if (purchaseMode === 'subscribe') {
        var bags = parseInt(selected.getAttribute('data-bags'), 10) || 0;
        gifts.forEach(function (g) {
          var need = parseInt(g.getAttribute('data-gift-unlock'), 10) || 1;
          var giftId = g.getAttribute('data-gift-variant-id');
          if (bags >= need && giftId) {
            items.push({ id: parseInt(giftId, 10), quantity: 1 });
          }
        });
      }
      return items;
    }

    function openCart(response) {
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.renderContents === 'function' && response.sections) {
        cart.renderContents(response);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    }

    function addToCart(purchaseMode, triggerBtn) {
      if (!selected || isLoading) return;
      if (selected.getAttribute('data-available') === 'false') return;
      showError('');

      isLoading = true;
      if (submit) submit.disabled = true;
      if (modeToggle) modeToggle.disabled = true;
      var btn = triggerBtn || submit;
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');
      }
      if (spinner && btn === submit) spinner.classList.remove('hidden');

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      var body = {
        items: buildItems(purchaseMode),
        sections: sections,
        sections_url: window.location.pathname,
      };

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            showError(response.description || response.message || 'Could not add to cart.');
            return;
          }
          openCart(response);
        })
        .catch(function () {
          showError('Something went wrong. Please try again.');
        })
        .finally(function () {
          isLoading = false;
          if (submit) submit.disabled = selected.getAttribute('data-available') === 'false';
          if (modeToggle) modeToggle.disabled = false;
          if (submit) { submit.classList.remove('loading'); submit.removeAttribute('aria-disabled'); }
          if (modeToggle) { modeToggle.classList.remove('loading'); modeToggle.removeAttribute('aria-disabled'); }
          if (spinner) spinner.classList.add('hidden');
        });
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('data-available') === 'false') return;
        selectBundle(b);
      });
      var input = b.querySelector('[data-bundle-radio]');
      if (input) {
        input.addEventListener('change', function () {
          if (input.checked) selectBundle(b);
        });
      }
    });

    // Buy Once = direct one-time purchase (no selling plan).
    if (modeToggle) {
      modeToggle.addEventListener('click', function () {
        addToCart('onetime', modeToggle);
      });
    }

    // TRY IT NOW = subscribe when a plan exists, otherwise a plain one-time add.
    if (submit) {
      submit.addEventListener('click', function () {
        addToCart(subscribeAvailable ? 'subscribe' : 'onetime', submit);
      });
    }

    selectBundle(selected);
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.pacoGalleryInit === 'true') return;
    gallery.dataset.pacoGalleryInit = 'true';
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length === 0) return;

    function swapMainImage(full) {
      if (!full || main.getAttribute('src') === full) return;
      // Preload so the new image is ready before we slide it in.
      var loader = new Image();
      loader.src = full;
      // Slide the current image out to the left.
      main.classList.add('is-leaving');
      setTimeout(function () {
        main.src = full;
        main.removeAttribute('srcset');
        // Jump to the right (no transition) then animate back into place.
        main.classList.remove('is-leaving');
        main.classList.add('is-entering');
        void main.offsetWidth;
        main.classList.remove('is-entering');
      }, 220);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMainImage(thumb.getAttribute('data-full'));
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    initSlider(gallery);
  }

  function initSlider(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var dotsWrap = gallery.querySelector('[data-gallery-dots]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    if (!track || dots.length === 0) return;
    var slides = Array.prototype.slice.call(track.children);

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    var hideTimer = null;
    function showDots() {
      if (!dotsWrap) return;
      dotsWrap.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        dotsWrap.classList.remove('is-visible');
      }, 1100);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = slides[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(i);
        showDots();
      });
    });

    track.addEventListener('touchstart', showDots, { passive: true });
    track.addEventListener('pointerdown', showDots, { passive: true });

    var raf = null;
    track.addEventListener('scroll', function () {
      showDots();
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        setActive(index);
      });
    }, { passive: true });

    // Briefly reveal on load so users notice they can swipe.
    showDots();
  }

  function initAll() {
    document.querySelectorAll('.paco-routine [data-buybox]').forEach(initBuybox);
    document.querySelectorAll('.paco-routine [data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target.querySelector) return;
    var root = event.target.querySelector('[data-buybox]');
    if (root) initBuybox(root);
    var gallery = event.target.querySelector('[data-gallery]');
    if (gallery) initGallery(gallery);
  });
})();
